import React from "react";
import { Link } from "react-router-dom";
import LegalLayout from "../components/legal/LegalLayout";
import { company } from "../legal/company";

const sections = [
  {
    id: "what-are-cookies",
    title: "1. What are cookies?",
    content: (
      <p>
        Cookies are small text files that a website stores on your device.
        Similar technologies, such as local storage or tracking pixels, work
        in a comparable way. They can be used to make a website work, remember
        your preferences, measure audiences or show targeted advertising.
      </p>
    ),
  },
  {
    id: "our-use",
    title: "2. Cookies we use",
    content: (
      <>
        <p>
          <strong>This website does not use cookies or similar tracking
          technologies.</strong> We do not use analytics tools, advertising
          trackers, social media pixels or retargeting, and we do not store
          anything in your browser's local storage.
        </p>
        <p>
          Because we set no cookies, you will not see a cookie consent banner
          on this website.
        </p>
      </>
    ),
  },
  {
    id: "third-party-content",
    title: "3. Third-party content",
    content: (
      <>
        <p>
          To display the website, your browser loads some resources directly
          from third parties. These requests share technical data such as your
          IP address with those providers, but they do not set cookies on our
          behalf:
        </p>
        <ul>
          <li>
            <strong>Google Fonts</strong> (Google LLC): the fonts used on the
            website.
          </li>
          <li>
            <strong>Partner logos</strong> loaded from external image hosts,
            such as Wikimedia Commons.
          </li>
        </ul>
        <p>
          The AI assistant and the contact form do not use cookies. What
          happens to the data you send through them is described in our{" "}
          <Link to="/privacy-policy">Privacy Policy</Link>.
        </p>
      </>
    ),
  },
  {
    id: "external-sites",
    title: "4. External websites",
    content: (
      <p>
        When you follow a link to another website, such as LinkedIn, GitHub,
        Facebook, Instagram or WhatsApp, that website may set its own cookies.
        This is governed by its own cookie and privacy policies, which we
        encourage you to read.
      </p>
    ),
  },
  {
    id: "managing-cookies",
    title: "5. Managing cookies in your browser",
    content: (
      <p>
        You can view, block or delete cookies at any time in your browser
        settings. Most browsers also let you block third-party cookies or
        browse in a private mode. Blocking cookies does not affect your use of
        this website.
      </p>
    ),
  },
  {
    id: "changes",
    title: "6. Changes to this policy",
    content: (
      <p>
        If we start using cookies, for example to measure the audience of the
        website, we will update this policy first and ask for your consent
        before setting any cookie that is not strictly necessary.
      </p>
    ),
  },
  {
    id: "contact",
    title: "7. Contact",
    content: (
      <p>
        Questions about this policy? Email us at{" "}
        <a href={`mailto:${company.email}`}>{company.email}</a>.
      </p>
    ),
  },
];

const CookiePolicy = () => (
  <LegalLayout
    title="Cookie Policy"
    description="Code Solutions does not use cookies or tracking technologies. Learn what third-party content the website loads and how to manage cookies."
    intro="Short version: we don't use cookies, analytics or tracking on this website. Here are the details."
    path="/cookie-policy"
    sections={sections}
  />
);

export default CookiePolicy;
